module.exports = __webpack_public_path__ + "media/images/signature-c5a64dfec9f1fea96c1565473eaf9e3e.jpg";